import {GetRefundPlans} from 'domain/usecases';
import {RemoteRefundGetPlans} from 'data/usecases';
import {makeAuthorizeHttpClientDecorator} from 'main/factories/decorators';
import {makeBFFApiUrl} from 'main/factories/http';
import {RefundFlowEndPoints} from '../../../endpoints';

export const makeGetRefundPlans = (): GetRefundPlans =>
	new RemoteRefundGetPlans(
		makeBFFApiUrl(RefundFlowEndPoints.plans),
		makeAuthorizeHttpClientDecorator(),
	);
